import React, { useState, useEffect } from 'react';
import { Card, Table, Tag, Spin } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import api from '../services/api';

const BajoStockCard = () => {
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBajoStock = async () => {
            try {
                const response = await api.get('/inventario/bajo-stock');
                setProductos(response.data);
            } catch (error) {
                console.error('Error cargando stock bajo', error);
            } finally {
                setLoading(false);
            }
        };
        fetchBajoStock();
    }, []);

    if (loading) return <Spin />;
    // if (!productos || productos.length === 0) return null; // Comentado para visualización, mejor mostrar mensaje de "Sin alertas" si se prefiere

    const columns = [
        { title: 'Código', dataIndex: 'codigo', key: 'codigo' },
        { title: 'Producto', dataIndex: 'nombre', key: 'nombre' },
        {
            title: 'Stock Actual',
            dataIndex: 'stock',
            key: 'stock',
            render: (stock) => <Tag color="red">{stock}</Tag>
        },
        { title: 'Stock Mínimo', dataIndex: 'stock_minimo', key: 'stock_minimo' }
    ];

    if (!productos || productos.length === 0) {
        return null;
    }

    return (
        <Card
            title={
                <span>
                    <WarningOutlined style={{ color: '#ff4d4f', marginRight: 8 }} />
                    Alerta de Inventario: Productos con Stock Bajo
                </span>
            }
            headStyle={{ backgroundColor: '#fff1f0', borderColor: '#ffa39e' }}
        >
            <Table
                dataSource={productos}
                columns={columns}
                rowKey="id"
                pagination={false}
                size="small"
            />
        </Card>
    );
};

export default BajoStockCard;
